const t=(e,r={})=>{if(typeof e=="object"){if(r&&r.getVideoUrl)return r.getVideoUrl(e);console.error("must set getVideoUrl in plugin config when using custom video source!",e)}return e};export{t as default};
//# sourceMappingURL=get-video-source.js.map
